import { render, staticRenderFns } from "./TodoCardSort.vue?vue&type=template&id=2c78de81"
import script from "./TodoCardSort.vue?vue&type=script&lang=js"
export * from "./TodoCardSort.vue?vue&type=script&lang=js"
import style0 from "./TodoCardSort.vue?vue&type=style&index=0&id=2c78de81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports